module.exports = __webpack_public_path__ + "static/img/s4.6e70b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/s4.png
// module id = txBG
// module chunks = 1